import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Flex, Link, Menu, MenuGroup, MenuList, Text, VStack, Checkbox } from '@chakra-ui/react';
import { BOOKING_CHANNEL, SEARCH_ROOM_PICKER, THIRTY_MINUTES } from '@whitbread-eos/api';
import { Accessible24, Alert, Button, DescriptionBox, Dropdown, Icon, Notification, OneAdult, Path, Switcher as Switch } from '@whitbread-eos/atoms';
import { formatDataTestId, getCookie, getRoomTypeOptions, setCookie } from '@whitbread-eos/utils';
import { useMemo } from 'react';
import { ADULTS_KEY, CHILDREN_KEY, ROOM_TYPE_KEY, SHOULD_INCLUDE_COT, SHOULD_BE_ACCESSIBLE } from './constants';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function DropdownContent(_ref) {
  var setIsOpen = _ref.setIsOpen,
    rooms = _ref.rooms,
    addRoom = _ref.addRoom,
    removeRoom = _ref.removeRoom,
    updateRoom = _ref.updateRoom,
    onSubmit = _ref.onSubmit,
    adultsOptions = _ref.adultsOptions,
    childrenOptions = _ref.childrenOptions,
    labels = _ref.labels,
    maxNumberOfRooms = _ref.maxNumberOfRooms,
    dataRoomOccupancyLimitations = _ref.dataRoomOccupancyLimitations,
    roomCodes = _ref.roomCodes,
    dataTestId = _ref.dataTestId,
    screenSize = _ref.screenSize,
    showMultipleRooms = _ref.showMultipleRooms,
    channel = _ref.channel,
    className = _ref.className,
    noRoomTypeSearch = _ref.noRoomTypeSearch,
    tabbingAccessibility = _ref.tabbingAccessibility,
    focusableRefs = _ref.focusableRefs;
  var roomOccupancies = dataRoomOccupancyLimitations.roomOccupancyLimitations.roomOccupancies;
  var isTestTargetRoomPickerRedesign = () => {
    if (typeof window !== 'undefined') {
      var horizontalRoomPickerCookie = getCookie(SEARCH_ROOM_PICKER);
      if (horizontalRoomPickerCookie) {
        return true;
      } else {
        var _window;
        if ((_window = window) !== null && _window !== void 0 && (_window = _window.piConfig) !== null && _window !== void 0 && _window.roomPickerRedesign && channel !== BOOKING_CHANNEL.CCUI) {
          var mode = window.piConfig.roomPickerRedesign.mode;
          (mode === null || mode === void 0 ? void 0 : mode.length) && setCookie(SEARCH_ROOM_PICKER, mode, THIRTY_MINUTES);
          return true;
        }
        return false;
      }
    }
  };
  var isTestTargetRoomPickerRedesignEnabled = isTestTargetRoomPickerRedesign();
  var onButtonClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    onSubmit();
    setIsOpen === null || setIsOpen === void 0 || setIsOpen(false);
  };
  var removeRoomButtonLabel = labels.removeRoomButtonLabel,
    roomsWarningTitle = labels.roomsWarningTitle,
    roomsWarningDescription = labels.roomsWarningDescription,
    roomsWarningDescriptionCCUI = labels.roomsWarningDescriptionCCUI,
    addMoreRoomsLabel = labels.addMoreRoomsLabel,
    doneButtonLabel = labels.doneButtonLabel,
    adultsLabel = labels.adultsLabel,
    adultsMaxPerRoomLabel = labels.adultsMaxPerRoomLabel,
    childrenLabel = labels.childrenLabel,
    childrenAgeLabel = labels.childrenAgeLabel,
    cotLimit = labels.cotLimit,
    cotLabel = labels.cotLabel,
    roomTypeLabel = labels.roomTypeLabel,
    roomLabel = labels.roomLabel,
    single = labels.single,
    double = labels.double,
    accessible = labels.accessible,
    twin = labels.twin,
    family = labels.family,
    accessibleRoom = labels.accessibleRoom;
  var roomTypeOccupancies = {
    single,
    double,
    accessible,
    twin,
    family
  };
  var isLessThanXs = screenSize.isLessThanXs,
    isLessThanSm = screenSize.isLessThanSm,
    isLessThanMd = screenSize.isLessThanMd;
  var rootPropsMenuList = useMemo(() => isLessThanXs ? menuListRootPropsLessThanXs : isLessThanSm ? menuListRootPropsLessThanSm : isLessThanMd ? menuListRootPropsLessThanMd : {}, [isLessThanXs, isLessThanSm, isLessThanMd]);
  return _jsx(MenuList, {
    "data-testid": isTestTargetRoomPickerRedesignEnabled ? 'roomPickerMenu-variant' : 'roomPickerMenu',
    w: menuListWidth,
    rootProps: rootPropsMenuList,
    overflow: "hidden",
    zIndex: "1801",
    sx: isTestTargetRoomPickerRedesignEnabled ? horizontalVariantStyles() : '',
    children: rooms.map((room, index) => {
      var isLastIndex = rooms.length === index + 1;
      return _jsx(MenuGroup, {
        children: _jsx(Menu, {
          flip: false,
          children: _jsxs(Box, _objectSpread(_objectSpread({
            as: "div",
            flexDirection: "column"
          }, menuItemStyles), {}, {
            role: "menuitem",
            children: [_jsxs(Flex, {
              w: "full",
              justifyContent: "".concat(rooms.length > 1 ? 'space-between' : 'start'),
              className: "roompicker-room-heading",
              children: [_jsxs(Box, _objectSpread(_objectSpread({}, roomLabelStyles), {}, {
                children: [roomLabel, " ", index + 1]
              })), rooms.length > 1 && _jsx(Link, {
                "data-testid": "remove-room-".concat(room.id),
                ref: el => {
                  if (!el || !focusableRefs) return;
                  focusableRefs.current = [...focusableRefs.current, el];
                },
                color: "btnSecondaryEnabled",
                textDecoration: "underline",
                onClick: () => removeRoom(room.id),
                onKeyDown: event => {
                  if (tabbingAccessibility && focusableRefs) {
                    tabbingAccessibility(event, focusableRefs);
                    if (event.key === ' ') {
                      event.preventDefault();
                      removeRoom(room.id);
                    }
                  }
                },
                tabIndex: 0,
                children: removeRoomButtonLabel
              })]
            }), _jsxs(VStack, {
              w: "full",
              mt: "2rem",
              className: "roompicker-stack",
              children: [_jsxs(Flex, {
                w: "full",
                justify: "space-between",
                className: "roompicker-occupancy",
                children: [_jsxs(VStack, {
                  spacing: 0,
                  sx: googleTranslateStyles(),
                  children: [_jsx(Dropdown, {
                    onChange: p => updateRoom(room.id, ADULTS_KEY, p === null || p === void 0 ? void 0 : p.id, labels),
                    dropdownStyles: {
                      menuButtonStyles: menuButtonStyles
                    },
                    label: adultsLabel,
                    icon: _jsx(Icon, {
                      svg: _jsx(OneAdult, {})
                    }),
                    placeholder: String(room.adults),
                    options: adultsOptions,
                    matchWidth: true,
                    dataTestId: "".concat(dataTestId, "-adults"),
                    tabbingAccessibility: tabbingAccessibility,
                    focusableRefs: focusableRefs
                  }), _jsx(Text, _objectSpread(_objectSpread({}, helperTextStyles), {}, {
                    children: adultsMaxPerRoomLabel
                  }))]
                }), _jsxs(VStack, {
                  spacing: 0,
                  sx: googleTranslateStyles(),
                  children: [_jsx(Dropdown, {
                    onChange: p => updateRoom(room.id, CHILDREN_KEY, p === null || p === void 0 ? void 0 : p.id, labels),
                    dropdownStyles: {
                      menuButtonStyles: menuButtonStyles
                    },
                    placeholder: String(room.children),
                    label: childrenLabel,
                    options: childrenOptions,
                    matchWidth: true,
                    dataTestId: "".concat(dataTestId, "-children"),
                    tabbingAccessibility: tabbingAccessibility,
                    focusableRefs: focusableRefs
                  }), _jsx(Text, _objectSpread(_objectSpread({}, helperTextStyles), {}, {
                    children: childrenAgeLabel
                  }))]
                })]
              }), !noRoomTypeSearch && _jsxs(_Fragment, {
                children: [_jsxs(Flex, _objectSpread(_objectSpread({}, cotSwitcherStyles), {}, {
                  className: "roompicker-cot-switcher",
                  children: [_jsx(Switch, {
                    size: "lg",
                    isChecked: room.shouldIncludeCot,
                    onChange: status => updateRoom(room.id, SHOULD_INCLUDE_COT, status.isChecked, labels)
                  }), _jsx(Text, _objectSpread(_objectSpread({}, cotLabelStyles), {}, {
                    children: cotLabel
                  })), _jsx(Text, _objectSpread(_objectSpread({}, cotLimitStyles), {}, {
                    children: cotLimit
                  }))]
                })), _jsx(Dropdown, {
                  dataTestId: "".concat(dataTestId, "-roomTypeDropdown"),
                  className: className,
                  onChange: p => updateRoom(room.id, ROOM_TYPE_KEY, p === null || p === void 0 ? void 0 : p.id, labels),
                  dropdownStyles: {
                    menuButtonStyles: {
                      w: '100%'
                    },
                    wrapperStyles: {
                      mt: '1.5rem'
                    }
                  },
                  placeholder: room.roomType,
                  tabbingAccessibility: tabbingAccessibility,
                  focusableRefs: focusableRefs,
                  label: roomTypeLabel,
                  matchWidth: true,
                  options: getRoomTypeOptions(room, roomOccupancies, roomTypeOccupancies, roomCodes).flat()
                })]
              }), noRoomTypeSearch && _jsxs(_Fragment, {
                children: [_jsxs(Flex, _objectSpread(_objectSpread({}, cotSwitcherStyles), {}, {
                  mb: "0",
                  className: "roompicker-accessible-switcher",
                  "data-testid": formatDataTestId(dataTestId, 'accessibleRoomSwitcher'),
                  children: [_jsx(Checkbox, {
                    size: "lg",
                    isChecked: room.shouldBeAccessible,
                    onKeyDown: event => {
                      if (tabbingAccessibility && focusableRefs) {
                        tabbingAccessibility(event, focusableRefs);
                      }
                    },
                    onChange: status => updateRoom(room.id, SHOULD_BE_ACCESSIBLE, status.target.checked, labels),
                    disabled: room.children > 0
                  }), _jsx(Text, _objectSpread(_objectSpread({
                    "data-testid": formatDataTestId(dataTestId, 'accessibleRoomLabel')
                  }, cotLabelStyles), {}, {
                    children: accessibleRoom
                  })), _jsx(Icon, {
                    ml: "0.625rem",
                    svg: _jsx(Accessible24, {})
                  })]
                })), _jsxs(Flex, _objectSpread(_objectSpread({}, cotSwitcherStyles), {}, {
                  mb: "0",
                  mt: "0.625rem",
                  className: "roompicker-cot-switcher",
                  "data-testid": formatDataTestId(dataTestId, 'cotRoomSwitcher'),
                  children: [_jsx(Checkbox, {
                    "data-testid": formatDataTestId(dataTestId, 'cotRoomCheckbox'),
                    size: "lg",
                    isChecked: room.shouldIncludeCot,
                    onKeyDown: event => {
                      if (tabbingAccessibility && focusableRefs) {
                        tabbingAccessibility(event, focusableRefs);
                      }
                    },
                    onChange: status => updateRoom(room.id, SHOULD_INCLUDE_COT, status.target.checked, labels)
                  }), _jsx(Text, _objectSpread(_objectSpread({}, cotLabelStyles), {}, {
                    children: cotLabel
                  })), _jsx(Text, _objectSpread(_objectSpread({}, cotLimitStyles), {}, {
                    children: cotLimit
                  }))]
                }))]
              }), isLastIndex ? renderButton(addRoom, onButtonClick, rooms, roomsWarningTitle, roomsWarningDescription, roomsWarningDescriptionCCUI, addMoreRoomsLabel, doneButtonLabel, maxNumberOfRooms, showMultipleRooms, channel, tabbingAccessibility, focusableRefs) : renderDivider()]
            })]
          }))
        })
      }, room.id);
    })
  });
}
function renderButton(addRoom, onButtonClick, rooms, roomsWarningTitle, roomsWarningDescription, roomsWarningDescriptionCCUI, addMoreRoomsLabel, doneButtonLabel, maxNumberOfRooms, showMultipleRooms, channel, tabbingAccessibility, focusableRefs) {
  return _jsxs(_Fragment, {
    children: [(rooms === null || rooms === void 0 ? void 0 : rooms.length) === maxNumberOfRooms ? _jsx(Box, {
      mt: "xl",
      children: _jsx(Notification, {
        variant: "alert",
        status: "warning",
        title: roomsWarningTitle,
        description: _jsx(DescriptionBox, {
          html: displayDescription(roomsWarningDescription, roomsWarningDescriptionCCUI, channel)
        }),
        svg: _jsx(Alert, {})
      })
    }) : _jsx(Flex, _objectSpread(_objectSpread({
      ref: el => {
        if (!el || !focusableRefs) return;
        focusableRefs.current = [...focusableRefs.current, el];
      },
      onClick: () => addRoom(),
      onKeyDown: event => {
        if (tabbingAccessibility && focusableRefs) {
          tabbingAccessibility(event, focusableRefs);
          if (event.key === ' ') {
            event.preventDefault();
            addRoom();
          }
        }
      },
      w: "full",
      pl: "md",
      alignItems: "center",
      "data-testid": "addMoreRooms",
      tabIndex: 0
    }, addAnotherRoomWrapperStyles), {}, {
      children: !showMultipleRooms && _jsxs(_Fragment, {
        children: [_jsx(Icon, _objectSpread(_objectSpread({}, addAnotherRoomButtonStyles), {}, {
          svg: _jsx(Path, {
            color: "var(--chakra-colors-primary)"
          })
        })), _jsx(Text, _objectSpread(_objectSpread({}, addAnotherRoomLabelStyles), {}, {
          "data-testid": "addMoreRoomsLabel",
          children: addMoreRoomsLabel
        }))]
      })
    })), _jsx(Box, {
      w: "full",
      ref: el => {
        if (!el || !focusableRefs) return;
        var button = el.querySelector('button');
        if (button) {
          focusableRefs.current = [...focusableRefs.current, button];
        }
      },
      children: _jsx(Button, _objectSpread(_objectSpread({
        w: "full",
        onClick: onButtonClick,
        size: "md",
        variant: "tertiary",
        "data-testid": "doneButton",
        onKeyDown: event => {
          if (tabbingAccessibility && focusableRefs) {
            tabbingAccessibility(event, focusableRefs);
          }
        }
      }, doneButtonStyles), {}, {
        children: doneButtonLabel
      }))
    })]
  });
}
function renderDivider() {
  return _jsx(Box, {
    w: "full",
    mt: "2rem",
    className: "roompicker-divider",
    children: _jsx(Divider, {
      orientation: "horizontal"
    })
  });
}
function displayDescription(roomsWarningDescription, roomsWarningDescriptionCCUI, channel) {
  if (channel && channel === BOOKING_CHANNEL.CCUI) {
    return roomsWarningDescriptionCCUI;
  }
  return roomsWarningDescription;
}
var menuButtonStyles = {
  w: '8.5rem'
};
var menuListWidth = {
  mobile: '20rem',
  xs: '21.4375rem',
  sm: '20rem',
  md: 'var(--chakra-space-breakpoint-m)'
};
var menuListRootPropsLessThanXs = {
  inset: '0 auto auto calc((100% + var(--chakra-space-8)) * -1)!important',
  transform: 'translate3d(var(--chakra-space-4), calc(var(--chakra-space-14) + 1px), 0)!important'
};
var menuListRootPropsLessThanSm = {
  inset: '0 auto auto calc((100% + var(--chakra-space-5)) * -1)!important',
  transform: 'translate3d(var(--chakra-space-4), calc(var(--chakra-space-14) + 1px), 0)!important'
};
var menuListRootPropsLessThanMd = {
  inset: '0 0 auto auto!important',
  transform: 'translate3d(0, calc(var(--chakra-space-14) + 1px), 0)!important'
};
var roomLabelStyles = {
  alignSelf: 'start',
  fontWeight: '600',
  fontSize: 'lg',
  textTransform: 'capitalize',
  as: 'h2'
};
var menuItemStyles = {
  height: 'auto',
  px: 'var(--chakra-space-md)',
  py: '7px',
  _hover: {
    backgroundColor: 'transparent'
  },
  _active: {
    backgroundColor: 'transparent'
  },
  _focus: {
    backgroundColor: 'transparent'
  }
};
var helperTextStyles = {
  color: 'darkGrey2',
  fontSize: 'var(--chakra-fontSizes-xs)',
  mt: '0.375rem!important',
  w: '7.5rem',
  ml: 'var(--chakra-space-md)!important'
};
var cotSwitcherStyles = {
  w: 'full',
  pl: '1rem',
  alignItems: 'center',
  mt: 'var(--chakra-space-xl) !important',
  mb: 'var(--chakra-space-lg) !important'
};
var cotTextStyles = {
  fontSize: 'md',
  lineHeight: '3'
};
var cotLabelStyles = _objectSpread(_objectSpread({}, cotTextStyles), {}, {
  ml: 'md',
  fontWeight: 'bold'
});
var cotLimitStyles = _objectSpread(_objectSpread({}, cotTextStyles), {}, {
  ml: 'sm',
  fontWeight: 'normal'
});
var addAnotherRoomWrapperStyles = {
  _hover: {
    cursor: 'pointer'
  }
};
var addAnotherRoomButtonStyles = {
  border: '0.063rem solid var(--chakra-colors-primary)',
  p: '0.5rem',
  margin: 'var(--chakra-space-lg) 0',
  borderRadius: '50%',
  cursor: 'pointer'
};
var addAnotherRoomLabelStyles = {
  fontSize: 'md',
  fontWeight: 'medium',
  marginLeft: 'md'
};
var doneButtonStyles = {
  _hover: {
    bg: 'baseWhite'
  }
};
var horizontalVariantStyles = () => ({
  '@media screen and (min-width: 1000px)': {
    width: '800px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: '80vh',
    '.roompicker-stack': {
      position: 'relative',
      justifyContent: 'normal',
      display: 'block',
      '.roompicker-divider': {
        marginTop: 'md',
        borderColor: 'lightGrey3'
      }
    },
    '.chakra-menu__menuitem': {
      paddingBottom: '6px'
    },
    '.roompicker-occupancy': {
      display: 'inline-block',
      width: 'auto',
      '.chakra-stack': {
        display: 'inline-block',
        paddingRight: 'md',
        '&:last-child': {
          display: 'inline-block',
          paddingRight: '0'
        }
      },
      '.chakra-text': {
        color: 'darkGrey1'
      },
      '.chakra-menu__menu-button': {
        minWidth: '150px'
      }
    },
    '.roompicker-cot-switcher': {
      display: 'inline-block',
      verticalAlign: 'top',
      width: '185px',
      paddingLeft: '0',
      position: 'absolute',
      top: '-1.2rem',
      marginLeft: '260px',
      '.chakra-switch': {
        float: 'left',
        paddingRight: '10px'
      },
      '.chakra-text': {
        fontSize: '15px',
        '&:last-child': {
          fontSize: 'sm',
          paddingLeft: '3.25rem'
        }
      }
    },
    '.roompicker-room-type': {
      width: '230px',
      display: 'inline-block',
      mt: '0',
      verticalAlign: 'top',
      marginLeft: 'md'
    },
    '.roompicker-room-heading': {
      justifyContent: 'normal',
      '.chakra-link': {
        paddingLeft: 'xl'
      }
    },
    '.chakra-button': {
      marginTop: 'lg'
    }
  }
});
var googleTranslateStyles = () => ({
  'button font': {
    pointerEvents: 'none'
  }
});